/**
 * IMPORTS
 */
import {_aggregates} from 'src/aggregates/index.d';
import {ICommand} from 'src/aggregates/index.d';


/**
 * TYPES
 */
import {AckTypes} from 'src/aggregates/conversations/message/messages.d';
import {ITemplateInput} from 'src/aggregates/conversations/queries.d';
import {IMessage} from 'src/aggregates/timelines/state.d';


/**
 * EXPORTS
 */
export enum _names
{
    TIMELINE_ADD = 'TIMELINE_ADD',
    TIMELINE_CLEAR_BY_CONVERSATION = 'TIMELINE_CLEAR_BY_CONVERSATION',
    TIMELINE_FETCH = 'TIMELINE_FETCH',
    TIMELINE_FOCUS = 'TIMELINE_FOCUS',
    TIMELINE_FETCH_MESSAGE_BY_ORIGINAL_ID =
        'TIMELINE_FETCH_MESSAGE_BY_ORIGINAL_ID',
    TIMELINE_LOAD_BY_CONTACT = 'TIMELINE_LOAD_BY_CONTACT',
    TIMELINE_LOAD_NEXT_CONVERSATION_MESSAGES =
        'TIMELINE_LOAD_NEXT_CONVERSATION_MESSAGES',
    TIMELINE_LOAD_NEXT_MESSAGES_BY_CONVERSATION =
        'TIMELINE_LOAD_NEXT_MESSAGES_BY_CONVERSATION',
    TIMELINE_ON_MESSAGE_ACK =
        'TIMELINE_ON_MESSAGE_ACK',
    TIMELINE_REMOVE = 'TIMELINE_REMOVE',
    TIMELINE_RESET_ERROR = 'TIMELINE_RESET_ERROR',
    TIMELINE_SEND_TEMPLATE = 'TIMELINE_SEND_TEMPLATE',
}


export interface ITimelineAdd extends ICommand
{
    _aggregate: _aggregates.TIMELINES;
    _name: _names.TIMELINE_ADD;
    account: number;
    application: string | null;
    contact: number | string;
    end: number | null;
    id: number;
    lastInteraction: number;
    messages: IMessage[];
    remote: string;
    start: number;
    status: number | null;
    subject: string | null;
}

export interface ITimelineClearByConversation extends ICommand
{
    _aggregate: _aggregates.TIMELINES;
    _name: _names.TIMELINE_CLEAR_BY_CONVERSATION;
}

interface ITimelineFetch extends ICommand
{
    _aggregate: _aggregates.TIMELINES;
    _name: _names.TIMELINE_FETCH;
}

export interface ITimelineFetchMessageByOriginalId extends ICommand
{
    _aggregate: _aggregates.TIMELINES;
    _name: _names.TIMELINE_FETCH_MESSAGE_BY_ORIGINAL_ID;
    message: number;
    reply: string;
}

interface ITimelineFocus extends ICommand
{
    _aggregate: _aggregates.TIMELINES;
    _name: _names.TIMELINE_FOCUS;
}


interface ITimelineLoadByContact extends ICommand
{
    _aggregate: _aggregates.TIMELINES;
    _name: _names.TIMELINE_LOAD_BY_CONTACT;
    contact: number | string;
}


export interface ITimelineLoadNextConversationMessages extends ICommand
{
    _aggregate: _aggregates.TIMELINES;
    _name: _names.TIMELINE_LOAD_MESSAGES;
}

export interface ITimelineLoadNextMessagesByConversation extends ICommand
{
    _aggregate: _aggregates.TIMELINES;
    _name: _names.TIMELINE_LOAD_NEXT_MESSAGES_BY_CONVERSATION;
    conversation: number;
}

export interface ITimelineOnMessageAck extends ICommand
{
    _aggregate: _aggregates.TIMELINES;
    _name: _names.TIMELINE_ON_MESSAGE_ACK;
    ack: AckTypes;
    id: number;
    originalId: string;
}

export interface ITimelineRemove extends ICommand
{
    _aggregate: _aggregates.TIMELINES;
    _name: _names.TIMELINE_REMOVE;
}

export interface ITimelineResetError extends ICommand
{
    _aggregate: _aggregates.TIMELINES;
    _name: _names.TIMELINE_RESET_ERROR;
}

export interface ITimelineSendTemplate extends ICommand
{
    _aggregate: _aggregates.TIMELINES;
    _name: _names.TIMELINE_SEND_TEMPLATE;
    templateInput: ITemplateInput;
}
